import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router';
import { PinIcon } from './Icons';
import '../styles/FeaturedProperty.css';

import img1 from '../images/katani/katani1.jpeg';
import img2 from '../images/katani/katani2.jpeg';
import img3 from '../images/katani/katani3.jpeg';
const FeaturedProperty = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isCarouselInView, setIsCarouselInView] = useState(false);
  const carouselRef = useRef(null);

  const carouselImages = [
    img1,
    img2,
    img3
  ];

  const property = {
    price: "1,650,000",
    location: "Katani, Syokimau"
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsCarouselInView(true);
          observer.disconnect();
        }
      },
      { 
        threshold: 0.1,
        rootMargin: '100px'
     }
    );

    if (carouselRef.current) observer.observe(carouselRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isCarouselInView) return;
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % carouselImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [isCarouselInView]);

  return (
    <section className="pricing-section">
      <div className="section-header">
        <h2>Prime Properties Ready For Development</h2>
        <p>
        Discover prime real estate opportunities offering great value for money, 
        with guaranteed title deed processing within 14 days of purchase.
        </p>
      </div>
      
      <div className="split-layout">
        <div className="carousel-container-wrapper" ref={carouselRef}>
          <div className="carousel">
            {carouselImages.map((img, index) => (
              <div 
                key={index}
                className={`carousel-item ${index === activeIndex ? 'active' : ''}`}
                style={{ backgroundImage: isCarouselInView ? `url(${img})` : 'none' }}
              />
            ))}
            <button 
              className="carousel-btn prev"
              onClick={() => setActiveIndex(prev => 
                prev === 0 ? carouselImages.length - 1 : prev - 1
              )}
            >
              &lt;
            </button>
            <button 
              className="carousel-btn next"
              onClick={() => setActiveIndex(prev => 
                (prev + 1) % carouselImages.length
              )}
            >
              &gt;
            </button>
          </div>
        </div>

        <div className="property-card">
          <div className="card-content">
            <h3 className="card-price"><span>Starting From </span>Ksh {property.price}</h3>
            <p className='card-description'>
                Escape the city and invest in prime, affordable plots at Amazon Courts Katani, a secure and gated community just 2Km from Utawala Town. 
            </p>
            <div className="card-location">
              <PinIcon className="pin-icon" />
              <p>{property.location}</p>
            </div>
            <div className="card-buttons">
              <Link to = {'/property/1'} className='show-more' >
              <button className="btn-show-more">Show More</button>
              </Link>
              <button className="btn-see-map">See Detailed Map</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProperty;